<template>
  <div class="home_box">
    <div style="margin-bottom: 70px">
      <Header />
    </div>
    <div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
export default {

  components: {
    Header,
    Footer
  }
}
</script>

<style scoped lang="less">
.home_box {
  min-height: 100vh;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  user-select: none;
}
</style>


// WEBPACK FOOTER //
// src/pages/newWebsite/main/main.vue